import type { ManagedDocVersion } from '@/managed-doc/managed-doc'
import { compareVersionsDesc } from '@/utility'

/** Get latest API version record based on version sorting */
export function getLatestApiVersion(versions: ManagedDocVersion[]) {
  return [...versions].sort((a, b) =>
    compareVersionsDesc(a.version, b.version),
  )[0]
}

/**
 * Extract relevant registry version from legacy WYSIWYG versions list
 *
 * If 'latest' is specified, this will be used as the version.
 * Otherwise the latest compared version (semver or compatible format) is used.
 */
export function getLegacyWysiwygVersion(versions: string[]): string {
  if (versions.includes('latest')) {
    return 'latest'
  }

  const latestVersion = [...versions].sort((a, b) =>
    compareVersionsDesc(a, b),
  )[0]

  return latestVersion ?? 'latest'
}
